"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GoogleDrive = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.21 13.052.705 1.219c.147.256.358.458.605.605l2.52-4.362H0c0 .284.073.568.22.824l.99 1.714Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.382 5.48 1.02a1.664 1.664 0 0 0-.605.605L.22 9.689a1.66 1.66 0 0 0-.22.825h5.04L8 5.382Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.48 14.876c.247-.147.458-.349.604-.605l.293-.504 1.402-2.429c.147-.256.22-.54.22-.824h-5.04l1.072 2.107 1.448 2.255Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 5.382 2.52-4.362A1.611 1.611 0 0 0 9.697.8h-3.39c-.294 0-.578.082-.826.22L8 5.382Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.96 10.514H5.04l-2.52 4.362c.247.146.531.22.824.22h9.31c.294 0 .578-.083.825-.22l-2.52-4.362Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.453 5.657-2.328-4.032a1.664 1.664 0 0 0-.605-.605L8 5.382l2.96 5.132h5.03a1.66 1.66 0 0 0-.22-.825l-2.317-4.032Z",
    fill: "#FFBA00"
  })));
});
var _default = GoogleDrive;
exports["default"] = _default;